console.log('csrfToken v0.0.1');

export const csrf = (() => {
  return {
    getToken: () => {
      let token = document.querySelector('#csrfToken').value;

      if (token) {
        return token.value;
      }
    }
  }
})();
